import { useEffect, useRef } from 'react'
import { gsap, isTouch } from '../lib/gsap'

// Pulls its child toward the pointer; an optional [data-magnetic-inner] follows further for depth.
export default function Magnetic({ children, strength = 0.35, inner = 0.2, className = '' }) {
  const wrap = useRef(null)

  useEffect(() => {
    if (isTouch()) return
    const node = wrap.current
    const target = node.firstElementChild
    if (!target) return
    const content = target.querySelector('[data-magnetic-inner]')
    const ease = 'elastic.out(1, 0.35)'
    const xTo = gsap.quickTo(target, 'x', { duration: 0.9, ease })
    const yTo = gsap.quickTo(target, 'y', { duration: 0.9, ease })
    const ixTo = content && gsap.quickTo(content, 'x', { duration: 0.9, ease })
    const iyTo = content && gsap.quickTo(content, 'y', { duration: 0.9, ease })

    const move = (e) => {
      const r = node.getBoundingClientRect()
      const dx = e.clientX - (r.left + r.width / 2)
      const dy = e.clientY - (r.top + r.height / 2)
      xTo(dx * strength)
      yTo(dy * strength)
      ixTo?.(dx * inner)
      iyTo?.(dy * inner)
    }
    const leave = () => {
      xTo(0)
      yTo(0)
      ixTo?.(0)
      iyTo?.(0)
    }
    node.addEventListener('pointermove', move)
    node.addEventListener('pointerleave', leave)
    return () => {
      node.removeEventListener('pointermove', move)
      node.removeEventListener('pointerleave', leave)
    }
  }, [strength, inner])

  return (
    <div ref={wrap} className={`inline-block ${className}`}>
      {children}
    </div>
  )
}
